// @flow
import * as React from 'react';
import {useLocation, useHistory} from "react-router-dom";
import styled from 'styled-components';
import ButtonIndex from 'components/ButtonIndex';
import GuideMessageContainer from 'components/GuideMessageContainer';
import GuideMessageCenter from 'components/GuideMessageCenter';
import Image, {BackgroundImage} from 'components/Image';
import {LayoutTop, LayoutWrapper} from 'components/Layout';
import {LocalizedParagraph, LocalizedParagraphFormat, Paragraph, useLocalized} from 'components/Localized';
import Logo from 'components/Logo';
import Space from 'components/Space';
import ButtonSpot from 'components/ButtonSpot';
import ButtonNextPage from 'components/ButtonNextPage';
import * as VRUtils from 'utils/vrUtils';
import * as VideoUtils from 'utils/videoUtils';
import ButtonList from './ButtonList';
import MenuUSP from './MenuUSP';
import ImgCar from 'assets/images/driving-zone/b/img-b-top-car.svg';
import ImgCircle from 'assets/images/driving-zone/b/img-notice-bg.svg';
import ImgTurnLeft from 'assets/images/driving-zone/b/ic-turn-left.svg';
import IconList from 'assets/images/driving-zone/b/img-features-dot.svg';
import ImgFeature from 'assets/images/driving-zone/b/img-features-banner.svg';
import Disclaimer from 'components/Disclaimer';
import * as AudioUtils from 'utils/audioUtils';
import LocalizedImage, {LocalizedBackgroundImage} from 'components/LocalizedImage';


function lookAtDefault() {
  const defaultLookAtPos = [-0.049745982243874214 , -0.49782771759446465 , 2.9579879818628876];
  VRUtils.ready(()=>{
    VRUtils.fireVREvent("smoothLookat", new window.pc.Vec3(defaultLookAtPos[0], defaultLookAtPos[1], defaultLookAtPos[2]) );
  });
  
}

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

type Props = {
  onOpenModalIndex: () => void,
  openModalIndex: boolean,
  onNext: () => void,
};

export default function DrivingExperience(props: Props): React.Element<any> {
  const history = useHistory();
  const goto = useQuery().get("goto");
  const gotoNo = React.useMemo(() => goto != null ? parseInt(goto) : null, [goto]);

  const localized = useLocalized();
  const [page, setPage] = React.useState(gotoNo ?? 0);
  //const [page, setPage] = React.useState(22);
  const [openList, setOpenList] = React.useState(false);
  //const timer = React.useRef(null);
  const [loadingCompleted, setLoadingCompleted] = React.useState(false);

  const [videoB04_2Completed, setVideoB04_2Completed] = React.useState(false);
  const [videoB04_4Completed, setVideoB04_4Completed] = React.useState(false);
  const [videoB04_9Completed, setVideoB04_9Completed] = React.useState(false);
  const [videoB04_17_before3_seconds, setVideoB04_17_before3_seconds] = React.useState(false);
  const [videoB04_12Completed, setVideoB04_12Completed] = React.useState(false);
  const [resultDisclaimerVisible, setResultDisclaimerVisible] = React.useState(false);

  React.useEffect(()=>{
    window.tagManager.drivingZoneCourseBStartAJourneyPage();
  },[]);

  React.useEffect(()=>{
    if (page === 27) {
      AudioUtils.playBGM_UI2();
    } else {
      AudioUtils.playBGM_UI2();
    }
    
    return ()=>{
    };
  }, [page]);

  React.useEffect(()=>{
    //window.tagManager.drivingZoneCourseBInCarExperiencePage();
    if (page === 0) {
      window.tagManager.drivingZoneCourseBCarExperienceJourney1();
    }
    if (page === 6) {
      window.tagManager.drivingZoneCourseBCarExperienceJourney2Highway();
    }
    if (page === 11) {
      window.tagManager.drivingZoneCourseBCarExperienceJourney2();
    }
    if (page === 12) {
      window.tagManager.drivingZoneCourseBCarExperienceJourney2HDA2();
    }
    if (page === 16) {
      window.tagManager.drivingZoneCourseBCarExperienceJourney3();
    }

  },[page]);  

  const refSpot2 = VideoUtils.CreateAddPoint3DCallback("DrivingExperience2", -1.3587117964695323 , -1.8415355585040625 , 1.9397548919643601, loadingCompleted, true,
      -1.347318837469675 , -0.9856153284320007 , 2.4926480647213802
    );

  //const refSpot5 = VideoUtils.CreateAddPoint3DCallback("DrivingExperience5", 0.005149752522686624 , -0.2709885641960121 , 2.987731359765121, loadingCompleted);
  const refSpot6 = VideoUtils.CreateAddPoint3DCallback("DrivingExperience6", 0.40300409313394364 , -1.4359024098909654 , 2.6030313041119206, loadingCompleted, true);
  const refSpot13 = VideoUtils.CreateAddPointCallback("DrivingExperience13", 0.36384976525821594, 0.6551904016692749);
  const refSpot18 = VideoUtils.CreateAddPointCallback("DrivingExperience18", 0.5154083204930663 , 0.5225132682759801);
  const refSpot20 = VideoUtils.CreateAddPointCallback("DrivingExperience20", 0.36413141062970733 , 0.5753930214723927);
  const refSpot22 = VideoUtils.CreateAddPointCallback("DrivingExperience22", 0.5192604006163328 , 0.4554014723506249);
  const refSpot24 = VideoUtils.CreateAddPointCallback("DrivingExperience24", 0.253562997289499 , 0.6839378238341969);
  
  console.log("DrivingExperience:page=", page, loadingCompleted, "gotoNo=", gotoNo, "goto=", goto);
  const handleNextPage = React.useCallback((next?: number, isGoTo?:boolean) => {

      if (isGoTo) {
        setVideoB04_2Completed(false);
        setVideoB04_4Completed(false);
        setVideoB04_9Completed(false);
        setVideoB04_17_before3_seconds(false);
        setVideoB04_12Completed(false);
      }
      if (page === 11) {
        window.tagManager.carExperienceJourney2NextLinkClick();
      }

      if (page === 14) {
        window.tagManager.carExperienceJourney2HDA2NextLinkClick();
      }

      if (page === 26) {
        window.tagManager.carExperienceJourney3NextLinkClick();
      }

      console.log("handleNextPage: next=", next, "isGoTo=", isGoTo);
      if (next === 2) {
        window.tagManager.carExperienceJourney1NextLinkClick();
      }
      
      const nextProvided = next != null && !isNaN(next);
      //console.log("next != null:", next != null, next);
      let nextPage = nextProvided ? (next ?? (page + 1)) : (page + 1);
      if (!nextProvided) {
        if (page === 0) {
          nextPage = 2;

        }
      }

      if (nextPage === 7) {
        //window.tagManager.navigationDriveModesLinkClick();
      }
      if (nextPage === 13) {
        //window.tagManager.navigationDrivingAssistantLinkClick();
      }
      if (nextPage === 17) {
        //window.tagManager.navigationParkingAssistLinkClick();
      }

      //console.log('next-page', next, nextPage);
      console.log("DrivingExperience, handleNextPage:(nextPage,nextProvided)=", nextPage, nextProvided);
      //console.trace();
      switch(nextPage) {
        case 0:
        VideoUtils.loadB04_1();
        setPage(nextPage);
        lookAtDefault();
        break;
        case 1:
        VideoUtils.loadB04_1();
        VideoUtils.play();
        
        lookAtDefault();

        setPage(nextPage);
        break;
        case 2:
        VideoUtils.loadB04_2();
        lookAtDefault();
        setPage(nextPage);
        break;
        case 3:
        break;
        case 4:
        break;
        case 5:
        if (videoB04_2Completed) {
          // VideoUtils.loadB04_3();
          // VideoUtils.play();
          lookAtDefault();
          setPage(nextPage);
        }
        break;
        case 6:
          if (gotoNo === 6 || isGoTo) {
            setVideoB04_9Completed(false);
            setVideoB04_12Completed(false);

            VideoUtils.loadB04_2(true);
            setVideoB04_2Completed(true);
            setVideoB04_4Completed(true);
            lookAtDefault();
          }
          else {
            VideoUtils.loadB04_2();
            VideoUtils.play();
            VideoUtils.onEnd(()=>{
              setVideoB04_2Completed(true);
              setVideoB04_4Completed(true);
            });
            lookAtDefault();
          }
          setPage(nextPage);
        break;
        case 7:
        lookAtDefault();
        VideoUtils.loadB04_5();
        VideoUtils.play();
        //lookAtDefault();
        setPage(nextPage);
        break;
        case 8:
        if (nextProvided) {
          setPage(nextPage);
          VideoUtils.loadB04_6();
          VideoUtils.play();
          //lookAtDefault();

        }

        break;
        case 9:
        if (nextProvided) {
          setPage(nextPage);
          VideoUtils.loadB04_7();
          VideoUtils.play();
          //lookAtDefault();
        }
        //setPage(nextPage);
        break;
        case 10:
        if (nextProvided) {
          setPage(nextPage);
          VideoUtils.loadB04_8();
          VideoUtils.play();
          //lookAtDefault();
        }
        //setPage(nextPage);
        break;
        case 11:
        //welcome to koln
        setPage(nextPage);
        VideoUtils.loadB04_9();
        //
        VideoUtils.onEnd(()=>{
          setVideoB04_9Completed(true);
        });

        VideoUtils.play();
        lookAtDefault();
        break;
        case 12:
        setPage(nextPage);
        VideoUtils.loadB04_10();
        VideoUtils.play();
        break;

        case 13:
        setPage(nextPage);
        VideoUtils.loadB04_11();
        VideoUtils.play();

        break;

        case 14:
        setPage(nextPage);
        VideoUtils.loadB04_12();
        VideoUtils.play();
        VideoUtils.onEnd(()=>{
          setVideoB04_12Completed(true);
        });
        break;

        case 15:
        setPage(nextPage);
        VideoUtils.loadB04_13();
        break;

        case 16:
        setPage(nextPage);
        VideoUtils.loadB04_13();
        break;

        case 17:
        setPage(nextPage);
        VideoUtils.loadB04_13();
        VideoUtils.play();
        VideoUtils.onEnd(()=>{
          handleNextPage(18);
        });
        break;

        case 18:
        setPage(nextPage);
        break;

        case 19:
        setPage(nextPage);
        VideoUtils.loadB04_14();
        VideoUtils.play();
        VideoUtils.onEnd(()=>{
          handleNextPage(20);
        });

        break;

        case 20:
        setPage(nextPage);
        break;

        case 21:
        setPage(nextPage);
        VideoUtils.loadB04_15();
        VideoUtils.play();
        VideoUtils.onEnd(()=>{
          handleNextPage(22);
        });

        break;
        case 22:
        setPage(nextPage);
        break;

        case 23:
        setPage(nextPage);
        VideoUtils.loadB04_16();
        VideoUtils.play();
        VideoUtils.onEnd(()=>{
          handleNextPage(24);
        });
        break;

        case 25:
        if (nextProvided) {
          setPage(nextPage);
          VideoUtils.loadB04_17();
          VideoUtils.play();
          setVideoB04_17_before3_seconds(false);
          VideoUtils.onEnd(()=>{
            handleNextPage(26);
          });
          VideoUtils.onTime((t, d)=>{
            if (videoB04_17_before3_seconds === false) {
              if (t >= d - 3.0) {
                setVideoB04_17_before3_seconds(true);
              }
            }
          });
        }
        break;

        case 26:
        setPage(nextPage);
        break;

        default:
        setPage(nextPage);
        break;
      }
      
    


    //setNextPage(next);
    
  }, [page, videoB04_2Completed,   videoB04_17_before3_seconds, gotoNo]);

  React.useEffect(()=>{
    let cancelWait = ()=>{};
    VRUtils.waitVREventListener(window.videoPlayer.VR_BIND_EVENT, ()=>{

      
      setLoadingCompleted(true);
      handleNextPage(page);
    }, (cancelWaitValue)=>{
      cancelWait = cancelWaitValue;
    });

    return ()=>{
      console.log("calling cancel wait");
      cancelWait();
      VideoUtils.unload();
    };
  //eslint-disable-next-line
  }, []);

  React.useEffect(() => {
    if (gotoNo != null) {
      handleNextPage(gotoNo);
      history.replace(history.location.pathname);
    }
    //eslint-disable-next-line
  }, [gotoNo]);

  if (!loadingCompleted) {
    return (<main></main>);
  }

  let disclaimerKey = "disclaimer_default";
  if (page >= 12 && page <= 14) {
    disclaimerKey = "disclaimer_HDA";
  }
  else if (page === 27) {
    disclaimerKey = "disclaimer_B_end";
  }
  // if (resultDisclaimerVisible) {
  //   disclaimerKey = "driving_b06_ui_016";
  // }
  console.log("disclaimer:resultDisclaimerVisible=", resultDisclaimerVisible);
  return (
    <main>
      <HUDBack />
      <HUD page={page} />
      <GuideMessageCenter show={page === 19} autoHide={3000} textKey="driving_b04_driving_210316_002" />
      <GuideMessageCenter show={page === 23} textKey="driving_b_04_driving8_210307_005" />

      { page >= 10 && page <= 12 && <GuideMessageCenter id="driving_b04_guide_027" show={page === 11} autoHide={3000} textKey="driving_b_04_driving8_210307_001"  />}
      <GuideMessageContainer onClick={handleNextPage}>
        <GuideMessageCenter show={page === 0}>
          <LocalizedParagraph {...localized.driving_b04_guide_007} />
          <Space heightM={13} heightD={21} />
          <LocalizedParagraph {...localized.driving_b04_guide_021} />
        </GuideMessageCenter>
        <GuideMessageCenter show={page === 1} localText={localized.driving_b04_guide_022} />
        <GuideMessageCenter show={page === 2} localText={localized.driving_b04_guide_023} />
        <GuideMessageCenter show={page === 4 && videoB04_2Completed}>
          <TurnLeftDiv style={{opacity : videoB04_2Completed? 1.0 : 0.0 }} >
            <div />
            <LocalizedParagraph {...localized.driving_b04_guide_061} />
          </TurnLeftDiv>
          <Space heightM={13} heightD={21} />
          <LocalizedParagraph {...localized.driving_b04_guide_025} />
        </GuideMessageCenter>
        <GuideMessageCenter show={page === 6 && videoB04_4Completed}>
          <Space heightM={5} heightD={38} />
          <GuideTitle><LocalizedParagraph {...localized.driving_b04_guide_041} /></GuideTitle>
          <Space heightM={13} heightD={21} />
          <LocalizedParagraph {...localized.driving_b04_guide_024} />
          <Space heightM={16} heightD={25} />
          <DivStart><Paragraph textKey="driving_b03_incar_210303_001" /></DivStart>
        </GuideMessageCenter>
        <GuideMessageCenter show={page === 8} autoHide={2000} localText={localized.driving_b04_driving_210303_001} />
        <GuideMessageCenter show={page === 9} autoHide={2000} localText={localized.driving_b04_driving_210303_002} />
        <GuideMessageCenter show={page === 10} autoHide={2000} localText={localized.driving_b04_driving_210303_003} />
        
        <GuideMessageCenter show={page === 11 && videoB04_9Completed}>
          <ImgNext source="./driving-zone/b/btn-b-04-next.png"/>
        </GuideMessageCenter>
        <GuideMessageCenter show={page === 12}>
          
          <GuideTitle><LocalizedParagraph {...localized.driving_b04_guide_042} /></GuideTitle>
          <Space heightM={13} heightD={21} />
          <LocalizedParagraph {...localized.driving_b04_guide_028} />
          <Space heightM={16} heightD={25} />
          <DivStart><Paragraph textKey="driving_b03_incar_210303_001" /></DivStart>
        </GuideMessageCenter>
        <GuideMessageCenter show={page === 14 && videoB04_12Completed}>
          <ImgNext source="./driving-zone/b/btn-b-04-next.png"/>
        </GuideMessageCenter>
        <GuideMessageCenter show={page === 15} textKey="driving_b_04_driving11_210307_002" autoHide={3000} handleAutoHide={()=>{
          if (page === 15) {
            handleNextPage(16);
          }
        }} />
        <GuideMessageCenter show={page === 16}>
          <Space heightM={5} heightD={38} />
          <GuideTitle><LocalizedParagraph {...localized.driving_b04_guide_043} /></GuideTitle>
          <Space heightM={13} heightD={21} />
          <LocalizedParagraph {...localized.driving_b04_guide_030} />
          <Space heightM={16} heightD={25} />
          <DivStart><Paragraph textKey="driving_b03_incar_210303_001" /></DivStart>
        </GuideMessageCenter>
        
        
        <GuideMessageCenter show={page === 25 && videoB04_17_before3_seconds === true} localText={localized.driving_b04_guide_031} />
      </GuideMessageContainer>
      {page >= 2 && page <= 3 && 
        <GuideDiv>
          <ButtonSpot ref={refSpot2}
            onClick={() => {
              console.log("button spot to page 4");
              VideoUtils.loadB04_2();
              VideoUtils.play();
              lookAtDefault();
              VideoUtils.onEnd(()=>{
                //setPage(5); 
                setVideoB04_2Completed(true);
              });
              handleNextPage(6); 
            } }
            >
            
          </ButtonSpot>
        </GuideDiv>}

        {(page >= 7 && page <= 9) && 
          <GuideDiv>
            <ButtonSpot id="refSpot6" ref={refSpot6} onClick={() => {
              console.log("page:", page);
              let nextPage = page + 1;
              handleNextPage(nextPage);

            } } >
            </ButtonSpot>
          </GuideDiv>}
        {page === 10 && <ButtonNextPage title={localized.driving_b04_guide_012} onNext={() => handleNextPage(11)} />}
        {page === 13 && 
        <GuideDiv>
          <ButtonSpot ref={refSpot13}
            onClick={() => {
              handleNextPage(14); 
            } }
            >
            
          </ButtonSpot>
        </GuideDiv>}
        {page === 18 && 
        <GuideDiv>
          <ButtonSpot ref={refSpot18}
            onClick={() => {
              handleNextPage(19); 
            } }
            >
            <ParagraphInSpotButton textKey="driving_b04_driving_210316_001" />
          </ButtonSpot>
        </GuideDiv>}
        {page === 20 && 
        <GuideDiv>
          <ButtonSpot ref={refSpot20}
            onClick={() => {
              handleNextPage(21); 
            } }
            >
          </ButtonSpot>
        </GuideDiv>}
        {page === 22 && 
        <GuideDiv>
          <ButtonSpot ref={refSpot22}
            onClick={() => {
              handleNextPage(23); 
            } }
            >
          </ButtonSpot>
        </GuideDiv>}
        {page === 24 && 
        <GuideDiv>
          <ButtonSpot ref={refSpot24}
            onClick={() => {
              handleNextPage(25); 
            } }
            >
          </ButtonSpot>
        </GuideDiv>}
        {page === 0 && <ButtonNextPage title={localized.driving_b04_guide_012} onNext={() => handleNextPage(2)} />}
        
        {page === 26 && <ButtonNextPage title={localized.driving_b04_guide_012} onNext={() => handleNextPage(27)} />}
        {page === 27 && <Result onDisclaimer={()=>{
          setResultDisclaimerVisible(true);
        }} onNext={ ()=>{
          window.tagManager.carExperienceCompletedTheJourneyNextLinkClick();
          props.onNext();

        }} />}
      {openList && page !== 27 && <MenuUSP section="driving-experience" page={page} onClose={() => setOpenList(false)}  onClick={[null, null, null, (menu) => handleNextPage(menu, true), (menu) => handleNextPage(menu, true), (menu) => handleNextPage(menu, true)]}/>}
      <Logo />
      {page !== 27 && <ButtonList onOpenList={() => setOpenList(!openList)} openList={openList} />}
      <ButtonIndex onOpenModalIndex={props.onOpenModalIndex} />
      {!resultDisclaimerVisible && <Disclaimer textKey={disclaimerKey} onPopupClose={()=>{
        setResultDisclaimerVisible(false);
      }} />}
      {resultDisclaimerVisible && <Disclaimer popupTextKey="disclaimer_eco_popup" onPopupClose={()=>{
        setResultDisclaimerVisible(false);
      }} />}

    </main>
  );
}

type PropsHUD = {
  page: number,
}

function HUD(props: PropsHUD): React.Element<any> {
  const localized = useLocalized();

  const carPos = React.useMemo(() => {
    if (props.page <= 6) {
      return 0;
    }
    else if (props.page >= 7 && props.page <= 10) {
      return 25;
    }
    else if (props.page >= 11 && props.page <= 11) {
      return 50;
    }
    else if (props.page >= 12 && props.page <= 14) {
      return 75;
    }
    else {
      return 100;
    }
  }, [props.page])

  const distanceText = React.useMemo(() => {
    if (props.page <= 6) return localized.driving_b04_distance_001;
    if (props.page >= 7 && props.page <= 10) return localized.driving_b04_distance_002;
    if (props.page >= 11 && props.page <= 11) return localized.driving_b04_distance_003;
    if (props.page >= 12 && props.page <= 14) return localized.driving_b04_distance_004;
    if (props.page >= 15) return localized.driving_b04_distance_005;
    return localized.driving_b04_distance_001;
  }, [localized, props.page])

  return (
    <HUDWrapper>
      <HUDCarWrapper source="./driving-zone/b/img-b-top-distance-bg.png" datacarpos={carPos}>
        <div><img src={ImgCar} alt="" /></div>
        <div><Image source="./driving-zone/b/img-b-top-distance-line.png" /></div>
        <div>
          <LocalizedParagraph {...localized.driving_b04_guide_001} />
          <LocalizedParagraph {...localized.driving_b04_guide_002} />
          <LocalizedParagraph {...localized.driving_b04_guide_003} />
        </div>
      </HUDCarWrapper>
      <BackgroundImage source="./driving-zone/b/img-b-top-empty-ic.png" />
      <HUDDistance source="./driving-zone/b/img-b-top-empty-bg.png">
        <BackgroundImage source="./driving-zone/b/img-b-top-empty-title.png">
          <LocalizedParagraphFormat format={localized.driving_b04_distance_011} args={[distanceText]} />
        </BackgroundImage>
      </HUDDistance>
    </HUDWrapper>
  );
}

type PropsResult = {
  onNext: () => void,
  onDisclaimer: () => void,
}

function Result(props: PropsResult): React.Element<any> {
  const localized = useLocalized();
  React.useEffect(()=>{
    window.tagManager.carExperienceCompletedTheJourneyPage();
  },[]);

  return (
  <React.Fragment>
    <LayoutWrapper><ResultBack source="./driving-zone/b/img-b-end-bg.jpg" /></LayoutWrapper>
  <ResultWrapper>
    <div>
      <div>
        <LocalizedParagraph {...localized.driving_b06_ui_001} />
        <LocalizedParagraph {...localized.driving_b06_ui_002} />
      </div>
    </div>
    <LocalizedBackgroundImage source="./driving-zone/b/img-b-result-distance.jpg" >
      <ResultTitleWrapper source="./driving-zone/b/img-b-result-title.png">
        <Paragraph textKey="driving_b06_ui3_310307_001"/>
      </ResultTitleWrapper>
    </LocalizedBackgroundImage>
    <ResultGridWrapper>
      <div>
        <div><ResultFeature><LocalizedParagraph {...localized.driving_b06_ui_006} /></ResultFeature></div>
        <div><img src={IconList} alt="" /><LocalizedParagraph {...localized.driving_b06_ui_011} /></div>
        <div><img src={IconList} alt="" /><LocalizedParagraph {...localized.driving_b06_ui_012} /></div>
        <div><img src={IconList} alt="" /><LocalizedParagraph {...localized.driving_b06_ui3_310307_003} /></div>
        <div><img src={IconList} alt="" /><LocalizedParagraph {...localized.driving_b06_ui_014} /></div>
        <div><img src={IconList} alt="" /><LocalizedParagraph {...localized.driving_b06_ui3_310307_004} /></div>
        <div><img src={IconList} alt="" /><LocalizedParagraph {...localized.driving_b06_ui3_310307_005} /></div>
        <div ><img src={IconList} alt="" /><button onClick={props.onDisclaimer}><LocalizedParagraph {...localized.driving_b06_ui_016} /> </button> </div>
      </div>
    </ResultGridWrapper>
  </ResultWrapper>
  <ButtonNextPage title={localized.driving_b04_guide_012} onNext={props.onNext}  />
  </React.Fragment>);
}

const HUDWrapper = styled(LayoutTop)`
  display: flex;
  flex-direction: row;
  justify-content: center;

  > :nth-child(1) {
    width: ${(props) => (props.theme.layout.mobile ? 335 : 670)}px;
    height: ${(props) => (props.theme.layout.mobile ? 50 : 100)}px;
  }
  > :nth-child(2) {
    width: ${(props) => (props.theme.layout.mobile ? 105 : 210)}px;
    height: ${(props) => (props.theme.layout.mobile ? 50 : 100)}px;
    margin-left: ${(props) => (props.theme.layout.mobile ? -50 : -100)}px;
    position: relative;
  }
  > :nth-child(3) {
    
  }
`;

const HUDBack = styled(LayoutWrapper)`
  height: ${(props) => (props.theme.layout.mobile ? 70 : 140)}px;
  background: linear-gradient(to bottom, rgba(0,0,0,0.4), rgba(0,0,0,0.0));
`;

const HUDCarWrapper = styled(BackgroundImage)`
  display: flex;
  flex-direction: column;

  > :nth-child(1) {
    flex: 1;
    padding-left: ${(props) => (props.theme.layout.mobile ? 57 : 115)}px;
    width: ${(props) => (props.theme.layout.mobile ? 206 : 410)}px;
    img {
      width: ${(props) => (props.theme.layout.mobile ? 29 : 48)}px;
      height: ${(props) => (props.theme.layout.mobile ? 11 : 18)}px;
      padding-top: ${(props) => (props.theme.layout.mobile ? 10 : 20)}px;
      position: relative;
      left: calc(${props => props.datacarpos}% - ${(props) => (props.theme.layout.mobile ? 29 * 0.5 : 48 * 0.5)}px);
      transition: left ease-in-out 0.25s;
    }
  }
  > :nth-child(2) {
    width: ${(props) => (props.theme.layout.mobile ? 206 : 410)}px;
    height: ${(props) => (props.theme.layout.mobile ? 6 : 10)}px;
    padding-left: ${(props) => (props.theme.layout.mobile ? 57 : 115)}px;
    padding-top: ${(props) => (props.theme.layout.mobile ? 2 : 4)}px;
  }
  > :nth-child(3) {
    padding-left: ${(props) => (props.theme.layout.mobile ? 10 : 16)}px;
    padding-right: ${(props) => (props.theme.layout.mobile ? 25 : 48)}px;
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;

    > p {
      flex: 1;
      text-align: center;
    }
  }
`;

const HUDDistance = styled(BackgroundImage)`
  height: ${(props) => (props.theme.layout.mobile ? 50 - 9 : 100 - 26)}px;
  padding-top: ${(props) => (props.theme.layout.mobile ? 9 : 26)}px;
  margin-left: ${(props) => (props.theme.layout.mobile ? -55 : -110)}px;
  padding-left: ${(props) => (props.theme.layout.mobile ? 15 : 31)}px;
  padding-right: ${(props) => (props.theme.layout.mobile ? 3 : 49)}px;
  background-size: cover;

  > :nth-child(1) {
    width: ${(props) => (props.theme.layout.mobile ? 114 : 185)}px;
    height: ${(props) => (props.theme.layout.mobile ? 32 : 48)}px;

    display: flex;
    align-items: center;
    justify-content: center;
    
    > p {
      padding-top: ${(props) => (props.theme.layout.mobile ? 7 : 5)}px;
    }
  }
`;

const GuideDiv = styled.div`
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
  button {
    pointer-events: auto;
  }
  position: absolute;
`;

const TurnLeftDiv = styled.div`
  width: ${(props) => (props.theme.layout.mobile ? 110 : 160)}px;
  height: ${(props) => (props.theme.layout.mobile ? 110 : 160)}px;
  background-size: cover;
  background-image: url(${ImgCircle});

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: opacity 1s;

  > div {
    width: ${(props) => (props.theme.layout.mobile ? 40 : 59)}px;
    height: ${(props) => (props.theme.layout.mobile ? 44 : 65)}px;
    margin-bottom: ${(props) => (props.theme.layout.mobile ? 6 : 7)}px;
    background-size: cover;
    background-image: url(${ImgTurnLeft});
  }

  > p {
    margin-bottom: ${(props) => (props.theme.layout.mobile ? 3 : 5)}px;
  }
`;

// const HDA2Div = styled(BackgroundImage)`
//   width: ${(props) => (props.theme.layout.mobile ? 110 : 160)}px;
//   height: ${(props) => (props.theme.layout.mobile ? 110 : 160)}px;
//   margin-bottom: ${(props) => (props.theme.layout.mobile ? 16 : 20)}px;
//   background-size: cover;
// `;

// const GuideSpot = styled.button`
//   width: ${(props) => (props.theme.layout.mobile ? 175 : 349)}px;
//   height: ${(props) => (props.theme.layout.mobile ? 64 : 127)}px;
//   left: calc(${(props) => (props.dataleft ?? 0) - (props.theme.layout.mobile ? 175 : 349) * 0.5}px - (env(safe-area-inset-left) * ${(props) => props.theme.layout.scale}));
//   top: calc(${(props) => (props.datatop ?? 0) - (props.theme.layout.mobile ? 64 : 127) * 0.5}px - (env(safe-area-inset-top) * ${(props) => props.theme.layout.scale}));
//   position: absolute;
//   transform: scale(${(props) => props.theme.layout.scale});
//   transform-origin: center center;
// `;

const GuideTitle = styled.div`
  padding: 0px 10px 8px;
  border-bottom: 1px solid #ffffff;
`;

const DivStart = styled.div`
  width: ${(props) => (props.theme.layout.mobile ? 110 : 180)}px;
  height: ${(props) => (props.theme.layout.mobile ? 40 : 64)}px;
  background-color: #ffffff;

  display:flex;
  align-items: center;
  justify-content: center;

  pointer-events: auto;
`;

const ResultWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  left:0px;
  top:${(props) => (props.theme.layout.mobile ? -10 : 0)}px;
  pointer-events:auto;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  >:nth-child(1) {
    flex: 1.24;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    > div {
      transform: scale(${props => props.theme.layout.scale});

      >:first-child {
        padding-top: ${(props) => (props.theme.layout.scale < 1 ? 0 : (props.theme.layout.mobile ? 22 : 44))}px;
      }

      > p {
        text-align: center;
      }
    }
  }
  >:nth-child(2) {
    width: ${(props) => (props.theme.layout.mobile ? 490 * props.theme.layout.scale : 860 * props.theme.layout.scale)}px;
    height: ${(props) => (props.theme.layout.mobile ? 175 * props.theme.layout.scale : 320 * props.theme.layout.scale)}px;
    margin-top: ${(props) => (props.theme.layout.mobile ? 0 : 33)}px;
    margin-bottom: ${(props) => (props.theme.layout.mobile ? 5 : 20)}px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;

    display: flex;
    align-items: top;
    justify-content: center;
  }
  >:nth-child(3) {
    flex: 1;
    > div {
      transform: scale(${props => props.theme.layout.scale});
      transform-origin: center top;
    }
  }
`;

const ResultTitleWrapper = styled(BackgroundImage)`
  width: ${(props) => (props.theme.layout.mobile ? 356 : 785)}px;
  height: ${(props) => (props.theme.layout.mobile ? 43 : 77)}px;

  position: relative;
  top: ${(props) => (props.theme.layout.mobile ? -19 : -33)}px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;

  > p {
    padding-bottom: ${(props) => (props.theme.layout.mobile ? 5 : 5)}px;
  }
`;

const ResultGridWrapper = styled.div`
  display: flex;
  justify-content: center;
  

  > div {
    width: ${(props) => (props.theme.layout.mobile ? 490 : 860)}px;
    height: ${(props) => (props.theme.layout.mobile ? 33 : 59)}px;
    display: grid;
    grid-template-columns: 89fr 116fr 107fr 98fr;
    row-gap: ${(props) => (props.theme.layout.mobile ? 4 : 11)}px;

    > div {
      display: flex;
      pointer-events: auto;

      img {

        display: inline;
        float : left;
        vertical-align: text-top;
        width: ${(props) => (props.theme.layout.mobile ? 4 : 8)}px;
        height: ${(props) => (props.theme.layout.mobile ? 4 : 8)}px;
        padding-top: ${(props) => (props.theme.layout.mobile ? 3 : 4)}px;
        padding-right: ${(props) => (props.theme.layout.mobile ? 6 : 12)}px;
      }

      button {
        display:block;
        align-self:flex-start;
        p {
          text-align: left;
        }
      }
      p {

        flex : 1;
      }
    }
  }
`;

const ResultFeature = styled.div`
  background-image: url(${ImgFeature});
  background-size: contain;
  background-repeat: no-repeat;

  display: flex;
  align-items: center;
  justify-content: center;

  width: ${(props) => (props.theme.layout.mobile ? 74 : 148)}px;
  height: ${(props) => (props.theme.layout.mobile ? 15 : 30)}px;

  > p {
    text-align: center;
  }
`;

const ResultBack = styled(BackgroundImage)`
  background-color: #000000;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
`;

const ImgNext = styled(LocalizedImage)`
  width: ${(props) => (props.theme.layout.mobile ? 110 : 180)}px;
  height: ${(props) => (props.theme.layout.mobile ? 110 : 180)}px;
`;

const ParagraphInSpotButton = styled(Paragraph)`
  position: relative;
  left: calc(-50vw + ${(props) => (props.theme.layout.mobile ? 32 : 52)}px);
  top: ${(props) => (props.theme.layout.mobile ? 20 : 30)}px;
  width: 100vw;
`;